<template>
  <section class="p-2">
    <v-card>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form v-model="valid" ref="filterForm">
            <v-row class="ms-1 me-1">
              <v-col cols="12" md="4" lg="2">
                <v-autocomplete
                  v-model="filterItems.senderCountry"
                  class="rounded"
                  dense
                  outlined
                  label="Sender Country"
                  :items="country_options"
                  :rules="FieldRequired('Channel Partner')"
                  item-text="txt"
                  item-value="val"
                  @change="getSendCountryPartners(filterItems.senderCountry)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="2">
                <v-autocomplete
                  v-model="filterItems.senderPartner"
                  class="rounded"
                  dense
                  outlined
                  hide-details
                  label="Channel Partner"
                  item-text="txt"
                  item-value="val"
                  :items="senderPartners"
                  :rules="FieldRequired('Channel Partner')"
                  placeholder="Channel Partner"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="2">
                <v-autocomplete
                  v-model="filterItems.payoutCountry"
                  class="rounded"
                  dense
                  outlined
                  hide-details
                  label="Payout Country"
                  item-text="txt"
                  item-value="val"
                  :items="country_options"
                  :rules="FieldRequired('Payout Country')"
                  placeholder="Payout Country"
                  @change="getpartnerTypes(filterItems.payoutCountry)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="2">
                <v-autocomplete
                  v-model="filterItems.payoutPartner"
                  class="rounded"
                  dense
                  outlined
                  hide-details
                  label="Payout Partner"
                  item-text="txt"
                  item-value="val"
                  :items="payoutPartner"
                  :rules="FieldRequired('Payout Partner')"
                  placeholder="Payout Partner"
                ></v-autocomplete>
              </v-col>
              <v-btn
                @click="getMasterData()"
                depressed
                small
                class="text-capitalize mt-1"
                color="primary"
                outlined
                >Get Results</v-btn
              >
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>
      <v-card-text>
        <v-row class="ms-1 mt-2">
          <v-btn
            depressed
            @click="downloadExcelsheet"
            class="ms-1 mt-1"
            color="primary"
            small
            ><v-icon small>mdi-file-excel-outline</v-icon>Export
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            class="ms-3 text-capitalize mt-1"
            color="primary"
            @click="openFormDialog()"
            ><v-icon small>mdi-content-save-plus-outline</v-icon>Add Master
            Data</v-btn
          >
        </v-row>
        <!-- -------------------------------modal to add category ------------------- -->
        <v-dialog persistent max-width="600px" v-model="dialog">
          <v-card>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-toolbar dark color="#050048" flat dense>
                <span class="subtitleFontsize">{{ formtitle }}</span>
                <v-spacer></v-spacer>
                <v-btn depressed small icon @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="">
                <v-row>
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Sending Country
                    </label>
                    <v-autocomplete
                      dense
                      outlined
                      placeholder="Sending Country"
                      disabled
                      :items="country_options"
                      item-text="txt"
                      item-value="val"
                      @input="
                        getSendCountryPartners(parameterdetails.send_country_cd)
                      "
                      v-model="parameterdetails.send_country_cd"
                      class="rounded"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Channel Partner
                    </label>
                    <v-autocomplete
                      dense
                      outlined
                      placeholder="Channel Partner"
                      :items="senderPartners"
                      item-text="txt"
                      item-value="val"
                      v-model="parameterdetails.send_partner_id"
                      class="rounded"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Payout Country
                    </label>
                    <v-autocomplete
                      dense
                      outlined
                      placeholder="Payout Partner"
                      :items="country_options"
                      item-text="txt"
                      item-value="val"
                      v-model="parameterdetails.pay_country_cd"
                      class="rounded"
                      @change="getpartnerTypes(parameterdetails.pay_country_cd)"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Payout Partner
                    </label>
                    <v-autocomplete
                      dense
                      outlined
                      placeholder="Payout Partner"
                      :items="payoutPartner"
                      item-text="txt"
                      item-value="val"
                      v-model="parameterdetails.pay_partner_id"
                      class="rounded"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Transaction Type
                    </label>
                    <v-autocomplete
                      dense
                      outlined
                      placeholder="Transaction Type"
                      :items="returnuserTypes"
                      item-text="txt"
                      item-value="val"
                      v-model="parameterdetails.txn_type"
                      class="rounded"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="">
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Parameter Type
                    </label>
                    <v-autocomplete
                      placeholder="Parameter Type"
                      dense
                      outlined
                      :items="parametersdataList"
                      @change="
                        getallparametersvalue(parameterdetails.parameter)
                      "
                      v-model="parameterdetails.parameter"
                      class="rounded"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="">
                  <v-col cols="12" md="12">
                    <label class="my-0 rounded labelFontsize required">
                      Parameter Values ({{
                        parameterdetails.parameter_value.length > 0
                          ? parameterdetails.parameter_value.length
                          : 0
                      }})
                    </label>
                    <v-autocomplete
                      placeholder="Parameter Values"
                      dense
                      outlined
                      :search-input.sync="searchInput"
                      @change="searchInput = ''"
                      multiple
                      :items="parametersdataValueList"
                      v-model="parameterdetails.parameter_value"
                      class="rounded"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider class="ma-0 pa-0"> </v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  depressed
                  small
                  color="primary"
                  @click="onclickNext()"
                  class="text-capitalize"
                >
                  <v-icon small class="me-2"
                    >mdi-content-save-plus-outline</v-icon
                  >Save
                </v-btn>
                <v-btn
                  depressed
                  small
                  color="primary"
                  class="text-capitalize ms-2"
                  @click="onClickBack()"
                  outlined
                >
                  <v-icon small class="me-2">mdi-close-circle-outline</v-icon>
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- -------------------------------modal to add category ------------------- -->

        <!-- ------------------------------- to delete the record ------------------- -->
        <v-dialog v-model="dialogDelete" width="500">
          <v-card>
            <v-card-title class="border border-bottom">Delete</v-card-title>
            <v-card-text class="h5 py-3"
              >Are you sure you want to delete this prameter?</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed small color="primary" outlined>
                <v-icon>mdi-check</v-icon>
              </v-btn>
              <v-btn depressed small color="primary" outlined
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- -----------------------category table Master Data------------------------- -->
        <v-data-table
          fixed-header
          height="55vh"
          :headers="headers"
          dense
          :search="search"
          class="mt-3 p-1"
          :items="parametersList"
          :loading="isLoading"
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.action="{ item }">
            <v-icon color="grey" class="mr-2" @click="nextpage(item)">
              mdi-chevron-right-circle
            </v-icon>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-switch
                v-model="item.is_active"
                height="0px"
                title="Update Status"
                dense
                color="success"
                @change="isactiveupdate(item)"
              ></v-switch>
            </div>
          </template>
        </v-data-table>

        <loading :active="isLoading" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import { Masterdata } from "@/utils/validationCopy.js";
import { FieldRequired } from "@/utils/validation.js";
import Loading from "vue-loading-overlay";
import { returnuserTypes } from "@/utils/ConstantDropdowns/index.js";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
import partnerService from "@/services/partnerService/partnerService.js";
export default {
  mixins: [alerts],
  name: "Master Data",
  data() {
    return {
      FieldRequired,
      returnuserTypes,
      ...Masterdata,
      item: ["Active", "In-Active"],
      dialogDelete: false,
      dialog: false,
      valid: true,
      isLoading: false,
      country_options: [],
      senderPartners: [],
      payoutPartner: [],
      selectedData: [],
      search: "",
      filterItems: {
        senderCountry: "MYS",
        senderPartner: null,
        payoutCountry: "",
        payoutPartner: null,
      },
      searchInput: "",
      headers: [
        {
          text: "Id",
          value: "id",
          width: 80,
          align: "start",
        },
        // {
        //   text: "Txn Type",
        //   value: "txn_type",
        //   sortable: false,
        // },
        {
          text: "Parameter Name",
          value: "parameter_name",
          sortable: false,
        },

        {
          text: "Parameter code",
          value: "parameter_code",
          sortable: false,
        },

        {
          text: "Sender Country",
          value: "send_country_cd",
          sortable: false,
        },

        {
          text: "Channel Partner",
          value: "send_partner_name",
          sortable: false,
        },
        {
          text: "Payout Coutry",
          value: "pay_country_cd",
          sortable: false,
        },
        {
          text: "Payout Partner",
          value: "pay_partner_name",
          sortable: false,
        },

        { text: "Actions", value: "actions", sortable: false, width: 200 },
        {
          text: "Navigation",
          value: "action",
          sortable: false,
          width: 100,
          align: "center",
        },
      ],
      parametersList: [],
      editedIndex: -1,
      parametersdataList: [],
      parametersdataValueList: [],
      parameterdetails: {
        map_level: "PW",
        send_country_cd: "",
        send_partner_id: 0,
        pay_country_cd: "",
        pay_partner_id: 0,
        branch: 0,
        parameter: 0,
        parameter_value: [],
        partner_parameter_value: "",
        partner_parameter_value_code: "",
        txn_type: "IND",
      },
      isclear: false,
      deleteId: "",
      is_active: "",
    };
  },

  components: {
    Loading,
  },
  watch: {
    selectedData(val) {
      console.log("Selected Data value===> ", val);
    },
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },

  mounted() {
    if (this.filterItems.senderCountry && this.filterItems.senderPartner) {
      this.getMasterData();
    }
    this.getBeneCountryList();
    this.getallparameters();
    this.getSendCountryPartners(this.filterItems.senderCountry);
  },

  methods: {
    // selectAll() {
    //   // Select all items
    //   this.parameterdetails.parameter_value = this.parametersdataValueList.map(
    //     (ele) => {
    //       return ele.value;
    //     }
    //   );
    //   this.isclear = true;
    //   console.log("test", this.parameterdetails.parameter_value);
    // },
    // clearAll() {
    //   this.isclear = false;
    //   this.parameterdetails.parameter_value = [];
    // },
    async downloadExcelsheet() {
      if (this.parametersList) {
        this.exportToExcel(
          this.headers,
          this.parametersList,
          "parameters_List",
        );
      }
    },
    async getMasterData() {
      if (this.$refs.filterForm.validate()) {
        const params = {
          sender_country: this.filterItems.senderCountry,
          sender_partner: this.filterItems.senderPartner,
          payout_country: this.filterItems.payoutCountry,
          payout_partner: this.filterItems.payoutPartner,
        };
        this.isLoading = true;
        try {
          const response = await setupService.getMasterPWDataList(params);
          if (response.data.status_code == 200) {
            this.parametersList = response.data.data[0];
            this.isLoading = false;
          } else {
            this.showAlertError(`Failed: ${response.data.message}`);
            this.isLoading = false;
          }
        } catch (e) {
          console.error(e);
          this.showAlertError("Something went wrong please try again later.");
          this.isLoading = false;
        }
      }
    },
    onclickNext() {
      console.log(`prametervalues: ${JSON.stringify(this.parameterdetails)}`);
      this.save();
    },

    async save() {
      this.isLoading = true;
      try {
        const response = await setupService.addMasterData(
          this.parameterdetails,
        );
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.isLoading = false;
          this.onClickBack();
          this.getMasterData();
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.isLoading = false;
      }
    },

    async isactiveupdate(item) {
      item.is_active ? false : true;
      this.isLoading = true;
      try {
        const response = await setupService.updatemappingStatus({
          parameter: item.parameter,
          country: item.send_country_cd,
          map_level: "PW",
          is_active: item.is_active,
          payout_partner_id: item.pay_partner_id,
          map_id: null,
        });
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.isLoading = false;
          this.getMasterData();
        } else {
          this.showAlertError(`Failed : ${response.data.message}`);
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.isLoading = false;
      }
    },

    openFormDialog() {
      this.dialog = true;
      this.editedIndex = -1;
      (this.parameterdetails = {
        map_level: "PW",
        send_country_cd: "",
        send_partner_id: 0,
        pay_country_cd: "",
        pay_partner_id: 0,
        branch: 0,
        parameter: 0,
        parameter_value: [],
        partner_parameter_value: "",
        partner_parameter_value_code: "",
        txn_type: "IND",
      }),
        (this.parameterdetails.send_country_cd =
          this.filterItems.senderCountry);
      this.parameterdetails.send_partner_id = this.filterItems.senderPartner;
      this.parameterdetails.pay_country_cd = this.filterItems.payoutCountry;
      this.parameterdetails.pay_partner_id = this.filterItems.payoutPartner;
      this.getSendCountryPartners(this.parameterdetails.send_country_cd);
    },
    editItem() {
      this.editedIndex = 1;
      this.dialog = true;
    },

    onClickBack() {
      this.dialog = false;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    async getSendCountryPartners(country_code) {
      try {
        const responseData = await partnerService.getCountryPartners(
          country_code,
        );
        if (responseData.data.status_code === 200) {
          this.senderPartners = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
        console.log("Partners", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getpartnerTypes(country_id) {
      try {
        const response = await partnerService.getAllPayoutPartners(country_id);
        if (response.data.status_code === 200) {
          console.log("response.data.data partner", response.data.data);
          this.payoutPartner = response.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },
    async getallparameters() {
      this.isLoading = true;
      try {
        const responseData = await setupService.getParameters();
        this.isLoading = false;
        if (responseData.data.status_code === 200) {
          this.parametersdataList = responseData.data.data.map((ele) => {
            return {
              text: ele.parameter_name,
              value: ele.id,
            };
          });
          console.log("getallparameters", responseData);
        }
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },
    async getallMainparameters() {
      this.isLoading = true;
      try {
        const responseData = await setupService.getallMainparameters({
          map_level: "CW",
        });
        this.isLoading = false;
        if (responseData.data.status_code === 200) {
          this.parametersdataList = responseData.data.data.map((ele) => {
            return {
              text: ele.parameter_name,
              value: ele.id,
            };
          });
          console.log("getallparameters", responseData);
        }
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },
    async getallparametersvalue(id) {
      this.isLoading = true;
      try {
        const responseData = await setupService.getParametersValuesUsertype({
          parameter_id: id,
          user_type: this.parameterdetails.txn_type,
        });
        this.isLoading = false;
        if (responseData && responseData.data.status_code == 200) {
          this.parametersdataValueList =
            responseData.data.data[0].parameter_values.map((ele) => {
              return {
                text: ele.value,
                value: ele.id,
              };
            });
        }
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
    async getBeneCountryList() {
      this.isLoading = true;
      try {
        const responseData = await commonService.getCountryBirthList();
        console.log(responseData);
        this.isLoading = false;
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
            };
          });
        }
        console.log("getBeneCountryList", responseData);
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },

    nextpage(item) {
      console.log("item " + item);
      this.$router.push({
        name: "Master Partner Value",
        query: {
          id: item.parameter,
          pay_partner_id: item.pay_partner_id,
          send_partner_id: item.send_partner_id,
          pay_country_cd: item.pay_country_cd,
          send_country_cd: item.send_country_cd,
          txn_type: item.txn_type,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
